import { Carrier } from '@/data/mobile/carrier';

export class Terminal {
  public id: string;
  public name: string;
  public charge: number;
  public image: string;
  public type: string;
  public attention: string;
  public carriers: Carrier[];

  constructor(
    id: string,
    name: string,
    charge: number,
    image: string,
    type: string,
    attention: string,
    carriers: Carrier[]
  ) {
    this.id = id;
    this.name = name;
    this.charge = charge;
    this.image = image;
    this.type = type;
    this.attention = attention;
    this.carriers = carriers;
  }

  public updateProperty(carrier: Carrier) {
    this.carriers = this.carriers.concat([carrier]);
  }

  public typeName(): string {
    switch (this.type) {
      case 'router':
        return 'ルーター';
      case 'iot':
        return 'IoT';
      case 'sp':
        return 'スマホ';
      case 'tablet':
        return 'タブレット';
      case 'feature':
        return 'フィーチャーフォン';
      default:
        return '';
    }
  }
}
